import { useState } from "react";

import { dispatch } from "../../state/store";
import {
  setFWUVersionsRefresh,
  setFWUVersionToDelete,
  setFWUVersionToEdit
} from "../../state/ducks";

import { strCode } from "../../consts";
import { fwuVersionsService, log, notificationService, t } from "../../services";

export const useDeleteFWUVersion = () => {
  const [loading, setLoading] = useState(false);

  const mutationCallback = async (firmwareToDelete) => {
    try {
      setLoading(true);

      await fwuVersionsService.deleteFWUVersion(firmwareToDelete);

      notificationService.showSuccess({
        title: t(strCode.DELETE_FWU_VERSION_SUCCESS),
        message: t(strCode.DELETE_FWU_VERSION_SUCCESS_INFO)
      });

      dispatch(setFWUVersionToDelete(null));
      dispatch(setFWUVersionToEdit(null));
      dispatch(setFWUVersionsRefresh(true));
    } catch (error) {
      log.error("useFetchFWUCampaigns: Failed to delete FWU version", error);

      notificationService.showError({
        title: t(strCode.DELETE_FWU_VERSION_ERROR),
        message: error?.response?.data?.message ? error.response.data.message : error?.toString()
      });
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading };
};
